import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=68143b28&scoped=true"
import script from "./AuthLayout.vue?vue&type=script&lang=ts"
export * from "./AuthLayout.vue?vue&type=script&lang=ts"
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=68143b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68143b28",
  null
  
)

export default component.exports